export default __webpack_public_path__ + "static/media/img-ltsh-3-right.606cca88.png";